// Central place for the legal-entity details shown on the Terms and Privacy
// pages. Update these before going live for real money — a lawyer should also
// review the wording of both documents.
export const COMPANY = {
  appName: 'FairPlay',
  // Your registered operating entity, e.g. "FairPlay (Pty) Ltd".
  legalEntity: 'FairPlay',
  // Company registration number, if registered (leave '' to hide the line).
  registrationNumber: '',
  website: 'https://www.fairplayed.app',
  // General/support + privacy contact.
  contactEmail: 'go@b-3data.com',
  privacyEmail: 'go@b-3data.com',
  // Registered/physical address (leave '' to hide the line).
  address: '',
  country: 'South Africa',
  governingLaw: 'the Republic of South Africa',
  minAge: 18,
};
